import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.css']
})
export class TutorialComponent implements OnInit {

  Submitted:boolean = false;
  BookTitleList=[];
  ChapterHeadingList=[];
  ChapterTopicList=[];
  SearchChapterHeadingList=[];
  SearchChapterTopicList=[];
  ChapterContentList=[];

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

    SearchModel = {    
     StaffID:0,
     ClassID:0,
     SectionID:0,
     CurrentIndex: 0,
     PageSize: 20,
  };

  ClearSearch(){
    this.SearchModel.ClassID=0;
    this.SearchModel.SectionID=0;
    this.SearchModel.StaffID=0;
    this.LearningTutorialList=[];
    this.pageSizes();
  }
  Content: '';
  LearningModel = {   
    TutorialID:0,
    ClassSectionID: "",
    ClassID:0,
    SectionID:0,
    StaffID:0,
    TutorialHeading: '',
    YouTubeUrls: '',   
    IsActive: true,
    IsShared:false,
};

  Clear() {
    this.LearningModel.TutorialID = 0;
    this.LearningModel.StaffID = 0;
    this.LearningModel.ClassID = 0;
    this.LearningModel.SectionID = 0;
    this.LearningModel.YouTubeUrls = '';
    this.LearningModel.TutorialHeading = '';
    this.LearningModel.ClassSectionID = '';
    this.Content = '';
    this.Submitted = false;
}

Edit(obj) {
  this.LearningModel.TutorialID = obj.TutorialID;
  this.LearningModel.ClassSectionID = obj.ClassSectionID;
  this.SetID();
  this.LearningModel.StaffID=obj.StaffID; 
  this.LearningModel.YouTubeUrls = obj.YouTubeUrls;
  this.LearningModel.TutorialHeading = obj.TutorialHeading;
  this.LearningModel.IsShared = obj.IsShared;
  this.Content = obj.Description;
  this.LearningModel.IsActive = obj.IsActive;

}

ValidityState(){
  return this.LearningModel.StaffID==0||this.LearningModel.ClassID==0||this.LearningModel.SectionID==0||this.LearningModel.TutorialHeading=='' ;
}

SelectedFileForUpload:any;
selectFileforUpload(file) {
  this.SelectedFileForUpload = file[0];
};


SaveLearningTutorial() {  
  this.Submitted = true;
  if (!this.ValidityState()) {
    this.spinnerService.show();
    this.learningservice.SaveLearningTutorial(JSON.stringify(this.LearningModel),this.Content).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllLearningTutorial();
      }
      if (data.webResponse.Status && this.LearningModel.TutorialID == 0) {
        this.Clear();
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }

};
LearningTutorialList=[];
GetAllLearningTutorial() {
  this.spinnerService.show();
  this.SearchModel.CurrentIndex = this.currentPage;
  this.SearchModel.PageSize = this.pageSize;
  this.learningservice.GetAllLearningTutorial(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.LearningTutorialList = data.LearningTutorialList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
    this.recordCount = 0;
    if (data.LearningTutorialList != null && data.LearningTutorialList.length > 0) {
        this.recordCount = data.LearningTutorialList[0].RecordCount;
    }
    this.numberOfPages();
  });
};

MarkActiveLearningTutorial(item) {
  this.LearningModel.TutorialID = item.TutorialID;
  this.LearningModel.IsActive = item.IsActive == true ? false : true;
  this.spinnerService.show();
  this.learningservice.MarkActiveLearningTutorial(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
      this.GetAllLearningTutorial();
    }
   
    this.globalHelper.CheckActionStatus(data);
    this.spinnerService.hide();
  });
};


ContentModel = {  
  TutorialResourceID:0,  
  TutorialID:0,
  ResourceType:'0',
  TutorialHeading: '',
  ResourcePath:'',
  IsShared:false, 
  ResourceName:'',
};
ClearResource(){
  this.ContentModel.TutorialResourceID=0;
  this.ContentModel.ResourceType='0';
  this.ContentModel.ResourcePath='';
  this.ContentModel.ResourceName='';
  this.ContentModel.IsShared=false;
  this.SubmittedResource=false;
  if(this.SelectedFileForUpload!=undefined && this.SelectedFileForUpload!=null)
  this.fileUploader.nativeElement.value = null;
}
GetContent(item){
  this.ContentModel.TutorialResourceID=0;
  this.ContentModel.ResourceType='0';
  this.ContentModel.ResourcePath='';
  this.ContentModel.ResourceName='';
  this.ContentModel.IsShared=false;
  this.ContentModel.TutorialID=item.TutorialID;  
  this.ContentModel.TutorialHeading=item.TutorialHeading;
  this.GetAllTutorialResource();
  
}

ValidityResorce(){
  return this.ContentModel.TutorialID==0||this.ContentModel.ResourceType=='0';
}
SubmittedResource=false;
SaveTutorialResource() {  
  this.SubmittedResource = true;
  if (!this.ValidityResorce()) {
    this.spinnerService.show();
    this.learningservice.SaveTutorialResource(JSON.stringify(this.ContentModel),this.SelectedFileForUpload).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllTutorialResource();
        if(this.SelectedFileForUpload!=undefined && this.SelectedFileForUpload!=null)
        this.fileUploader.nativeElement.value = null;
        this.SelectedFileForUpload=null;
      }
      if (data.webResponse.Status && this.ContentModel.TutorialResourceID==0) {
        this.ClearResource();
      }
      this.SubmittedResource=false;
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }
};

TutorialResourceList=[];
GetAllTutorialResource() {
  this.spinnerService.show();
  this.learningservice.GetAllTutorialResource(JSON.stringify(this.ContentModel)).subscribe((data: any) => {
    this.TutorialResourceList = data.TutorialResourceList;
    if (this.TutorialResourceList != null) {
      for (var i = 0; i < this.TutorialResourceList.length; i++) {
        this.TutorialResourceList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.TutorialResourceList[i].YouTubeUrls);
      }

    }
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};

DeleteTutorialResource(item) {  
  this.ContentModel.TutorialResourceID=item.TutorialResourceID;
  if(confirm("Are you sure to delete this resource !")) {
    this.spinnerService.show();
    this.learningservice.DeleteTutorialResource(JSON.stringify(this.ContentModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllTutorialResource();
        this.ContentModel.TutorialResourceID=0;
      }
      
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }
};

embedURL(url){
  return this._sanitizer.bypassSecurityTrustResourceUrl(url);

  
 
}

EditResource(item){
  this.ContentModel.TutorialResourceID=item.TutorialResourceID;
  this.ContentModel.ResourceType=item.ResourceType;
  this.ContentModel.ResourcePath=item.ResourcePath!=null?item.ResourcePath:'';  
  this.ContentModel.IsShared=item.IsShared;  
  this.ContentModel.ResourceName=item.ResourceName;
}
  ngOnInit() {
    this.GetClass();
    this.GetSection();
    this.GetClassSection();  
  }
  ClassList=[];
  GetClass() {
    this.LookupService.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  }
 
  ClassSectionList: any;
  GetClassSection() {
    this.LookupService.GetLookupsList('STClassSection', '').subscribe((data) => {
      this.ClassSectionList = data.LookupItems;
    
    });

  };
  SetID() {
    this.LearningModel.ClassID = 0;
    this.LearningModel.SectionID = 0;
    if (this.LearningModel.ClassSectionID != "") {
      var strClassSectionID = this.LearningModel.ClassSectionID.split('-');
      this.LearningModel.ClassID = parseInt(strClassSectionID[0]);
      this.LearningModel.SectionID = parseInt(strClassSectionID[1]);
      this.GetSubjectTeacher();
    }
  }
  SectionList=[];
  GetSection() {
    this.SearchModel.SectionID=0;
    var ItemBO={
     'ItemID':this.SearchModel.ClassID
   }
    this.LookupService.GetLookupsList('LPSection', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
    });
  }

  
  SubjectTeacherList=[];
  GetSubjectTeacher() {
    this.LearningModel.StaffID=0;
    var ItemBO={
     'ItemID':this.LearningModel.ClassID,
     'ItemID1':this.LearningModel.SectionID
   }
    this.LookupService.GetLookupsList('AllClassSubjectTeacher', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectTeacherList = data.LookupItems;
    });
  }
 

   // Paging

   currentPage = 1;
   pageSize = 20;
   recordCount = 0;
   totalPages = 0;
   numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }
 
    nextPage() {
    this.currentPage = this.currentPage + 1;
    }
 
    pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
    }
 
 
}






